import { z } from 'zod';

// Painel "Orçamento de IA" (RQ-IA-021), só do superadministrador: o gasto do mês com IA da empresa da URL (chamadas com
// empresa) e o do sistema (sem empresa: a leitura da base comum, ADR-0019), em US$. Sem limite nem aviso por ora.

export const esquemaFiltroOrcamentoIa = z.object({ mes: z.string().regex(/^\d{4}-(0[1-9]|1[0-2])$/).optional() });
export type FiltroOrcamentoIa = z.infer<typeof esquemaFiltroOrcamentoIa>;

export type TotalIaDto = { custoUsd: number; chamadas: number; tokensEntrada: number; tokensSaida: number };

export type OrcamentoIaDto = {
  /** AAAA-MM, no horário de Brasília. */
  mes: string;
  empresa: TotalIaDto;
  sistema: TotalIaDto;
  /** Uma linha por tipo de chamada (finalidade da ia_chamada), em ordem alfabética. */
  porTipo: { finalidade: string; empresa: TotalIaDto; sistema: TotalIaDto }[];
  /** Gasto acumulado em US$ em cada dia do mês; nulo nos dias que ainda não chegaram. */
  dias: { dia: string; empresa: number | null; sistema: number | null }[];
};
